<template>
	<div class="relative h-[90vh] md:h-[90vh] w-[95%] md:w-[93%] lg:w-[85%] xl:w-[80%] mx-auto flex flex-col md:flex-row items-center justify-center rounded-2xl pt-4 shadow-2xl pair-bg">
		<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkLogo : lightLogo" alt="Logo" class="absolute top-6 left-6 w-36 h-auto md:w-44"/>
			<div class="py-6 mt-10 max-w-md w-full overflow-hidden custom-scrollbar">
			<h2 class="text-xl md:text-2xl font-archivomedium mt-6 md:mt-0 mb-4 text-center text-[var(--text-color)] mt-20">Pairing Device</h2>
			<div class="flex flex-col items-center h-60 md:h-80">
				<qrcode-stream @decode="onDecode" @init="onInit" class="w-full h-60 md:h-80 rounded-lg"></qrcode-stream>
			</div>
			<div class="p-4">
				<p class="mt-2 mb-4 text-sm md:text-md text-center font-archivolight text-[var(--secondary-text-color)]">Scan the QR codes on your Cardware Hardware...</p>
			<div class="flex justify-center mb-2">
				<div class="loader"></div>
			</div>
			<p class="mb-4 text-center text-[var(--accent-color)]">
				{{percentSynced}}
			</p>
			<button @click="backToPair" class="mt-2 font-archivoregular w-full py-2 px-4 bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 mb-8 shadow-inner rounded-full">
				Back
			</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {ref, computed} from 'vue';
	import lightLogo from '../assets/CWWLogo.png';
	import darkLogo from '../assets/LogoWhite1.png';
	import QRCodeVue from 'qrcode.vue';
	import { QrcodeStream } from 'vue3-qrcode-reader';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		callback: { type: Function, required: true },
		qrDecode: { type: Function, required: true },
		qrInit: { type: Function, required: true },
		percentSynced: { type: String, default: '0 %' }
	});

	const backToPair = () => {
		props.callback();
	}

	const onDecode = (result) => {
		props.qrDecode(result);
	}

	const onInit = (promise) => {
		props.qrInit(promise);
	}
</script>

<style scoped>
	.loader {
		border: 8px solid #f3f3f3;
		border-top: 8px solid var(--accent-color);
		border-radius: 50%;
		width: 28px;
		height: 28px;
		animation: spin 1s linear infinite;
	}
	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	.lightTheme-bg {
		background: var(--bg-color);
	}

	.pair-bg {
		background: var(--main-bg-color);
	}
	.popup-bg {
		background: var(--popup-bg-color);
	}
	
</style>